import { render, staticRenderFns } from "./Wizards.vue?vue&type=template&id=199f8065&"
import script from "./Wizards.vue?vue&type=script&lang=js&"
export * from "./Wizards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports